<template>
  <div class="starMember" :class="[isMVP ? 'isMVP' : '']">
    <img class="posterBg" :src="starMemberBg" />
    <main>
      <section>
        <dl>
          <dt :style="{ visibility: isMVP ? 'visible' : 'hidden' }">
            {{ teamInfo.teamName || "" }}
          </dt>
          <dd>{{ teamInfo.servicePointName || "" }}</dd>
        </dl>
      </section>
      <section
        class="userInfo"
        :class="{ 'MvpUserInfo' : isMVP && isSpring, 'MvpUserInfoNew' : officialPoster}"
      >
        <dl>
          <dt :style="{ color: '#FBF497' }" v-if="!isSpring">
            {{ posterData.realName || "张三" }}
          </dt>
          <dt :style="{ color: isMVP ? '#FBF497' : '#ffffff' }" v-if="isSpring">
            {{ posterData.realName || "张三" }}
          </dt>
          <dd :class="[season == 'autumn' ? 'autumn' : '']">
            <!-- <img
              src="../../../../assets/images/winterGame/poster/memberJb.png"
              v-if="isSpring"
            />
            <img 
              src="../../../../assets/images/squirrelCup/2023/summer/poster/memberJb.png"
              v-if="season == 'summer'"
            /> -->
            <img
              src="../../../../assets/images/squirrelCup/2023/autumn/poster/memberJb.png"
            />
            {{ posterData.cupNumber | formatNumberFilter }}
          </dd>
        </dl>
        <ul>
          <li v-if="isMVP">战队单日奖杯数最多</li>
          <li v-else>服务中心单日奖杯数最多</li>
          <li>
            {{ timeFormatFilter(posterData.date) }}
          </li>
        </ul>
        <img
          class="committeeSeal"
          :class="[this.season + '_' + this.year]"
          src="../../../../assets/images/winterGame/poster/committeeSeal.png"
        />
      </section>
      <footer></footer>
    </main>
  </div>
</template>

<script>
import starMemberBg1 from "@images/winterGame/poster/starMemberBg1.png";
import starMemberBg2 from "@images/winterGame/poster/starMemberBg2.png";
import { timeFormatFilter, judgeTempSeason } from "@/util/util.js";

export default {
  name: "starMember",
  data() {
    return {
      isSpring: false,
      year: "",
      season: "",
      star_type: "service",
      starMemberBg: null,
      currentSeason: "",
    };
  },
  methods: {
    timeFormatFilter(date) {
      return timeFormatFilter(date);
    },
    initSeasonInfo() {
      // 初始化基础季节信息
      [this.isSpring, this.year, this.season] = judgeTempSeason();
      
      // 从路由参数获取季节信息
      if (this.$route.query.seasonId) {
        const { seasonId } = this.$route.query;
        this.updateSeasonFromRoute(seasonId);
      }
    },
    updateSeasonFromRoute(seasonId) {
      // 更新季节信息
      const seasonMap = {
        'chunji': { isSpring: true, season: 'spring' },
        'xiaji': { isSpring: false, season: 'summer' },
        'qiuji': { isSpring: false, season: 'autumn' },
        'winter': { isSpring: false, season: 'winter' }
      };

      // 从 seasonId 中提取年份
      const yearMatch = seasonId.match(/s\.(\d{2})/);
      if (yearMatch) {
        this.year = `20${yearMatch[1]}`;
      }

      // 更新季节
      for (const [key, value] of Object.entries(seasonMap)) {
        if (seasonId.includes(key)) {
          this.isSpring = value.isSpring;
          this.season = value.season;
          break;
        }
      }
    },
    setStarMemberBg() {
      const imageType = this.isMVP ? 'star_person_team' : 'star_person_service';
      this.starMemberBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/${imageType}.png`);
    }
  },
  props: {
    posterData: {
      type: Object,
      default: function () {
        return {
          realName: "",
          date: "",
          cupNumber: 0,
        };
      },
    },
    teamInfo: {
      type: Object,
      default: null,
    },
    isMVP: {
      type: Boolean,
      default: false,
    },
    // 2024冬季赛背景判断
    officialPoster:{
      type: Boolean,
      default: false,
    }
    // year: {
    //   type: Number,
    //   default: 2023,
    // },
    // season: {
    //   type: String,
    //   //default:'spring'
    //   default: "summer",
    // },
  },
  mounted() {
    this.initSeasonInfo();
    this.setStarMemberBg();
  },
};
</script>

<style lang="less" scoped>
.starMember {
  display: flex;
  flex-direction: column;
  > img {
    width: 100%;
  }
  main {
    position: absolute;
    top: 572px;
    left: 0;
    right: 0;
  }

  section {
    position: relative;
    margin-top: 30px;
    &:first-child {
      dl {
        text-align: center;
        dt {
          height: 66px;
          font-size: 48px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 66px;
          margin-bottom: 16px;
        }
        dd {
          margin-left: 0;
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 44px;
        }
      }
    }
    &.userInfo {
      position: relative;
      display: flex;
      flex-direction: column;
      margin-top: 62px;
      height: 482px;

      background: url("../../../../assets/images/squirrelCup/2025/summer/poster/userInfoBg.png")
        no-repeat;
      background-size: contain;
      &.MvpUserInfo {
        background: url("../../../../assets/images/winterGame/poster/MvpBg.png")
          no-repeat;
        background-size: contain;
      }
      &.MvpUserInfoNew {
        background: url("../../../../assets/images/squirrelCup/2024/spring/poster/MvpBg.png")
          no-repeat;
        background-size: contain;
      }

      dl {
        margin-top: 52px;
        text-align: center;
        dt {
          height: 112px;
          font-size: 80px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fbf497;
          line-height: 112px;
        }
        dd {
          margin: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 64px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;

          img {
            width: 70px;
            height: 76px;
            margin-right: 10px;
          }
          &.autumn {
            margin: 30px 0 0 0;
          }
        }
      }
      ul {
        margin-top: 30px;
        text-align: center;
        li {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 44px;
          margin-bottom: 8px;
        }
      }
      img.committeeSeal {
        position: absolute;
        bottom: -250px;
        right: 10px;
        width: 259px;
        float: left;
      }
      .summer_2023 {
        top: 380px !important;
        right: 60px !important;
      }
    }
  }
  // footer {
  // }
}
</style>
